import {useEffect, useId, useState} from "react";
import {HideMainLoading, HideProgressLoading, ShowProgressLoading} from "../../../components/template/architecture";
import {AuthRedirectParents, PostJSON} from "../../../components/api/webservice";
import {Apis} from "../../../components/api/url";
import {ShowConnectionFailed} from "../../../components/template/connection-failed";
import '../../../static/css/profile/profile.css';
import {
    CheckPhoneNumberFormat,
    FixStringWithNumbers,
    StringDigitsConvertToPersian
} from "../../../components/techaran/money";
import DatePicker, {DayValue} from "@hassanmojab/react-modern-calendar-datepicker";
import {DateFixToGoLayout, GregorianToPersian, PersianToGregorian} from "../../../components/techaran/date-convert";
import {CheckIcon} from "../../../components/icons/material-icons";
import {ShowSnackbar} from "../../../components/template/snackbar";
import {useNavigate} from "react-router-dom";
import {BreadCrumbs} from "../../../components/open/pages";

export const StudentsProfileScreen = (props:{isStandAlone:boolean}) => {
    const [loaded, setLoaded] = useState(false);
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [national, setNational] = useState('');
    const [homeTell, setHomeTell] = useState('');
    const [birthDate, setBirthDate] = useState<DayValue>(null);
    const [fatherName, setFatherName] = useState('');
    const [fatherCert, setFatherCert] = useState('');
    const [fatherTell, setFatherTell] = useState('');
    const [fatherJob, setFatherJob] = useState('');
    const [motherName, setMotherName] = useState('');
    const [motherTell, setMotherTell] = useState('');
    const [motherCert, setMotherCert] = useState('');
    const [motherJob, setMotherJob] = useState('');
    const [zipcode, setZipcode] = useState('');
    const [address, setAddress] = useState('');
    const [whoGetsSMS, setWhoGetsSMS] = useState('' as '' | 'father' | 'mother');
    const [livesWith, setLivesWith] = useState('' as '' | 'both' | 'father' | 'mother');
    const ids = {
        firstName: useId(),
        lastName: useId(),
        national: useId(),
        homeTell: useId(),
        birthDate: useId(),
        fatherName: useId(),
        fatherCert: useId(),
        fatherTell: useId(),
        fatherJob: useId(),
        motherName: useId(),
        motherTell: useId(),
        motherCert: useId(),
        motherJob: useId(),
        zipcode: useId(),
        address: useId(),
        livesWith: useId(),
    };
    const [errors, setErrors] = useState({
        firstName: false,
        lastName: false,
        homeTell: false,
        birthDate: false,
        fatherName: false,
        fatherCert: false,
        fatherTell: false,
        fatherJob: false,
        motherName: false,
        motherTell: false,
        motherCert: false,
        motherJob: false,
        zipcode: false,
        address: false,
        livesWith:false,
        whoGetsSMS:false,
    });
    const fetchData = () => {
        HideMainLoading();
        ShowProgressLoading();
        PostJSON(
            Apis.server + "/core/parents/account/profile/get",
            {},
            true,
            (d: {
                result: string,
                reason: string | undefined,
                firstname: string,
                lastname: string,
                nationalCode: string,
                fatherName: string,
                homeTell: string,
                birthDate: string,
                fatherCertificate: string,
                fatherTell: string,
                fatherJob: string,
                motherFullname: string,
                motherTell: string,
                motherCertificate: string,
                motherJob: string,
                zipcode: string,
                address: string,
                whoGetsSMS: '' | 'father' | 'mother',
                livesWith:''|'both'|'father'|'mother',
            }) => {
                HideProgressLoading();
                if (d.result !== 'OK') {
                    if (d.reason === 'login')
                        AuthRedirectParents();
                    return;
                }
                setFirstName(d.firstname);
                setLastName(d.lastname);
                setNational(d.nationalCode);
                setHomeTell(d.homeTell.replaceAll('+98','0'));
                setFatherName(d.fatherName);
                setFatherCert(d.fatherCertificate);
                setFatherTell(d.fatherTell.replaceAll('+98','0'));
                setFatherJob(d.fatherJob);
                setMotherName(d.motherFullname);
                setMotherTell(d.motherTell.replaceAll('+98','0'));
                setMotherCert(d.motherCertificate);
                setMotherJob(d.motherJob);
                setZipcode(d.zipcode);
                setAddress(d.address);
                setWhoGetsSMS(d.whoGetsSMS);
                setLivesWith(d.livesWith);
                const bd = d.birthDate.split('-');
                if (bd.length === 3) {
                    const tt = GregorianToPersian(d.birthDate).split('-');
                    setBirthDate({
                        year: parseInt(tt[0]),
                        month: parseInt(tt[1]),
                        day: parseInt(tt[2]),
                    });
                } else {
                    setBirthDate(null);
                }
                setLoaded(true);
            },
            () => {
                HideMainLoading();
                HideProgressLoading();
                ShowConnectionFailed('fa');
            },
            AuthRedirectParents,
            'parents',
        ).then(void 0);
    };
    let navigate = useNavigate();
    useEffect(() => {
        document.title = "تکمیل اطلاعات | نهال";
        fetchData();
    }, []);
    const saveData = () => {
        let data = {
            firstname:firstName.trim(),
            lastname:lastName.trim(),
            homeTell:FixStringWithNumbers(homeTell.trim()),
            birthDate:birthDate === null ? "" : DateFixToGoLayout(`${birthDate?.year}-${birthDate?.month}-${birthDate?.day}`),
            fatherName:fatherName.trim(),
            fatherCert:fatherCert.trim(),
            fatherTell:FixStringWithNumbers(fatherTell.trim()),
            fatherJob:fatherJob.trim(),
            motherName:motherName.trim(),
            motherTell:FixStringWithNumbers(motherTell.trim()),
            motherCert:motherCert.trim(),
            motherJob:motherJob.trim(),
            zipcode:FixStringWithNumbers(zipcode.trim()),
            address:FixStringWithNumbers(address.trim()),
            whoGetsSMS:whoGetsSMS,
            livesWith:livesWith,
        };
        if(data.livesWith !== 'both'){
            data.whoGetsSMS = data.livesWith === 'mother' ? 'mother' : 'father';
        }
        let err = {
            firstName: false,
            lastName: false,
            homeTell: false,
            birthDate: false,
            fatherName: false,
            fatherCert: false,
            fatherTell: false,
            fatherJob: false,
            motherName: false,
            motherTell: false,
            motherCert: false,
            motherJob: false,
            zipcode: false,
            address: false,
            livesWith:false,
            whoGetsSMS:false,
        };
        let stop = false;
        if(data.firstname.length < 2){
            stop = true;
            err.firstName = true;
        }
        if(data.lastname.length < 2){
            stop = true;
            err.lastName = true;
        }
        if(data.homeTell.length < 5){
            stop = true;
            err.homeTell = true;
        }
        if(data.birthDate === ''){
            stop = true;
            err.birthDate = true;
        }
        if(livesWith === 'father' || livesWith === 'both'){
            if(data.fatherName.length < 2){
                stop = true;
                err.fatherName = true;
            }
            if(data.fatherCert.length < 2){
                stop = true;
                err.fatherCert = true;
            }
            if(data.fatherJob.length < 2){
                err.fatherJob = true;
                stop = true;
            }
        }
        if(livesWith === 'father' || livesWith === 'both' || data.fatherTell !== ''){
            if(!CheckPhoneNumberFormat(data.fatherTell)){
                stop = true;
                err.fatherTell = true;
            }
        }
        if(livesWith === 'mother' || livesWith === 'both'){
            if(data.motherName.length < 2){
                err.motherName = true;
                stop = true;
            }
            if(data.motherCert.length < 2){
                stop = true;
                err.motherCert = true;
            }
            if(data.motherJob.length < 2){
                stop = true;
                err.motherJob = true;
            }
        }
        if(livesWith === 'mother' || livesWith === 'both' || data.motherTell !== ''){
            if(!CheckPhoneNumberFormat(data.motherTell)){
                stop = true;
                err.motherTell = true;
            }
        }
        if(data.zipcode.length < 4){
            err.zipcode = true;
            stop = true;
        }
        if(data.address.length < 3){
            stop = true;
            err.address = true;
        }
        if(data.livesWith === ''){
            stop = true;
            err.livesWith = true;
        }
        if(data.whoGetsSMS === ''){
            stop = true;
            err.whoGetsSMS = true;
        }
        setErrors(err);
        if(stop)
            return;
        data.fatherTell = "+98" + data.fatherTell.substring(1);
        data.motherTell = '+98' + data.motherTell.substring(1);
        data.birthDate = PersianToGregorian(data.birthDate);
        ShowProgressLoading();
        PostJSON(
            Apis.server + '/core/parents/account/profile/save',
            {
                firstname:data.firstname,
                lastname:data.lastname,
                fatherName:data.fatherName,
                homeTell:data.homeTell,
                birthDate:data.birthDate,
                fatherCert:data.fatherCert,
                fatherTell:data.fatherTell,
                fatherJob:data.fatherJob,
                motherName:data.motherName,
                motherTell:data.motherTell,
                motherCert:data.motherCert,
                motherJob:data.motherJob,
                zipcode:data.zipcode,
                address:data.address,
                whoGetsSMS:data.whoGetsSMS,
                livesWith:data.livesWith,
            },
            true,
            (d: {
                result:string,
                reason:string|undefined,
            })=>{
                HideProgressLoading();
                if(d.result !== 'OK'){
                    if(d.reason === 'login')
                        AuthRedirectParents();
                    else if(d.reason === 'fill')
                        ShowSnackbar('لطفا موارد خواسته شده را تکمیل کنید.','باشه',5000);
                    return;
                }
                if(props.isStandAlone)
                    navigate('/students/overview',{replace:true});
                ShowSnackbar(
                    'مشخصات دانش‌آموز ثبت گردید.',
                    'باشه',
                    5000,
                );
            },
            ()=>{},
            AuthRedirectParents,
            'parents',
        ).then(void 0);
    };
    return (
        <>
            {
                !props.isStandAlone ?
                    <BreadCrumbs links={[
                        {title: 'پنل دانش‌آموزان', url: '/students/'},
                        {title: 'پروفایل', url: '/students/profile'},
                    ]}/> : null
            }
            <div data-aos={"fade" + (props.isStandAlone ? '' : '-up')} data-aos-duration={1000}>
                <div className="container profile-screen-container" style={{paddingTop: 5}}>
                    <div className="screen-card" style={{paddingTop: 0, paddingBottom: 0}}>
                        <div className="profile-screen">
                            <b className="profile-title">
                                تکمیل اطلاعات دانش‌آموز
                            </b>
                            <span className="profile-title-span">
                                {
                                    props.isStandAlone ?
                                        'لطفا برای ادامه، ابتدا مشخصات دانش‌آموز را تکمیل و تایید کنید.':
                                        'می‌توانید اطلاعات دانش‌آموز را در این قسمت ویرایش نمایید.'
                                }
                            </span>
                            <div className="row">
                                <div className="col-lg-4 col-md-6">
                                    <label data-necessary={"yes"} htmlFor={ids.firstName}>نام:</label>
                                    <input type="text"
                                           id={ids.firstName}
                                           className={"form-control" + (errors.firstName ? ' is-invalid' : '')}
                                           value={firstName}
                                           onChange={e => {
                                               const t = e.currentTarget.value;
                                               setFirstName(t);
                                               setErrors(v => {
                                                   let x = {...v};
                                                   x.firstName = false;
                                                   return x;
                                               });
                                           }}
                                           onKeyUp={e => {
                                               if (e.which === 13)
                                                   (document.getElementById(ids.lastName) as HTMLInputElement).focus();
                                           }}
                                    />
                                    <div
                                        className={"invalid-feedback " + (errors.firstName ? 'd-block' : 'd-none')}>
                                        لطفا حداقل ۲ کاراکتر وارد کنید.
                                    </div>
                                    <div style={{height: 20}}/>
                                    <label data-necessary={"yes"} htmlFor={ids.lastName}>نام خانوادگی:</label>
                                    <input type="text"
                                           id={ids.lastName}
                                           className={"form-control" + (errors.lastName ? ' is-invalid' : '')}
                                           value={lastName}
                                           onChange={e => {
                                               const t = e.currentTarget.value;
                                               setLastName(t);
                                               setErrors(v => {
                                                   let x = {...v};
                                                   x.lastName = false;
                                                   return x;
                                               });
                                           }}
                                           onKeyUp={e => {
                                               if (e.which === 13)
                                                   (document.getElementById(ids.fatherName) as HTMLInputElement).focus();
                                           }}
                                    />
                                    <div
                                        className={"invalid-feedback " + (errors.lastName ? 'd-block' : 'd-none')}>
                                        لطفا حداقل ۲ کاراکتر وارد کنید.
                                    </div>
                                    <div style={{height: 20}}/>
                                    <label
                                        data-necessary={livesWith === 'both' || livesWith === 'father' ? 'yes' : 'no'}
                                        htmlFor={ids.fatherName}>نام پدر:</label>
                                    <input type="text"
                                           id={ids.fatherName}
                                           className={"form-control" + (errors.fatherName ? ' is-invalid' : '')}
                                           value={fatherName}
                                           onChange={e => {
                                               const t = e.currentTarget.value;
                                               setFatherName(t);
                                               setErrors(v => {
                                                   let x = {...v};
                                                   x.fatherName = false;
                                                   return x;
                                               });
                                           }}
                                           onKeyUp={e => {
                                               if (e.which === 13)
                                                   (document.getElementById(ids.homeTell) as HTMLInputElement).focus();
                                           }}
                                    />
                                    <div
                                        className={"invalid-feedback " + (errors.fatherName ? 'd-block' : 'd-none')}>
                                        لطفا حداقل ۲ کاراکتر وارد کنید.
                                    </div>
                                    <div style={{height: 20}}/>
                                    <label data-necessary={"yes"} htmlFor={ids.homeTell}>تلفن منزل:</label>
                                    <input type="text"
                                           id={ids.homeTell}
                                           className={"form-control" + (errors.homeTell ? ' is-invalid' : '')}
                                           value={homeTell}
                                           onChange={e => {
                                               const t = e.currentTarget.value;
                                               setHomeTell(StringDigitsConvertToPersian(t));
                                               setErrors(v => {
                                                   let x = {...v};
                                                   x.homeTell = false;
                                                   return x;
                                               });
                                           }}
                                    />
                                    <div
                                        className={"invalid-feedback " + (errors.homeTell ? 'd-block' : 'd-none')}>
                                        لطفا حداقل ۵ کاراکتر وارد کنید.
                                    </div>
                                    <div style={{height: 20}}/>
                                    <label data-necessary={"yes"}>تاریخ تولد:</label>
                                    <DatePicker
                                        value={birthDate}
                                        locale={'fa'}
                                        onChange={e => setBirthDate(e)}
                                        shouldHighlightWeekends={true}
                                        inputPlaceholder={"انتخاب تاریخ..."}
                                        wrapperClassName={"datepicker-wrapper-1"}
                                        inputClassName={"form-control form-control-datepicker"}
                                    />
                                    <div
                                        className={"invalid-feedback " + (errors.birthDate ? 'd-block' : 'd-none')}>
                                        لطفا یک تاریخ را انتخاب کنید.
                                    </div>
                                    <div style={{height: 20}}/>
                                    <label data-necessary={livesWith === 'father' || livesWith === 'both' ? 'yes' : ''}
                                           htmlFor={ids.fatherCert}>مدرک تحصیلی پدر:</label>
                                    <input type="text"
                                           id={ids.fatherCert}
                                           className={"form-control" + (errors.fatherCert ? ' is-invalid' : '')}
                                           value={fatherCert}
                                           onChange={e => {
                                               const t = e.currentTarget.value;
                                               setFatherCert(t);
                                               setErrors(v => {
                                                   let x = {...v};
                                                   x.fatherCert = false;
                                                   return x;
                                               });
                                           }}
                                           onKeyUp={e => {
                                               if (e.which === 13)
                                                   (document.getElementById(ids.fatherTell) as HTMLInputElement).focus();
                                           }}
                                    />
                                    <div
                                        className={"invalid-feedback " + (errors.fatherCert ? 'd-block' : 'd-none')}>
                                        لطفا حداقل ۲ کاراکتر وارد کنید.
                                    </div>
                                    <div style={{height: 20}}/>
                                </div>
                                <div className="col-lg-4 col-md-6">
                                    <label data-necessary={livesWith === 'father' || livesWith === 'both' ? 'yes' : ''}
                                           htmlFor={ids.fatherTell}>تلفن‌همراه پدر:</label>
                                    <input type="text"
                                           id={ids.fatherTell}
                                           className={"form-control" + (errors.fatherTell ? ' is-invalid' : '')}
                                           value={fatherTell}
                                           onChange={e => {
                                               const t = e.currentTarget.value;
                                               setFatherTell(StringDigitsConvertToPersian(t));
                                               setErrors(v => {
                                                   let x = {...v};
                                                   x.fatherTell = false;
                                                   return x;
                                               });
                                           }}
                                           onKeyUp={e => {
                                               if (e.which === 13)
                                                   (document.getElementById(ids.fatherJob) as HTMLInputElement).focus();
                                           }}
                                    />
                                    <div
                                        className={"invalid-feedback " + (errors.fatherTell ? 'd-block' : 'd-none')}>
                                        لطفا تلفن همراه را بصورت ۱۱ رقمی وارد کنید.
                                    </div>
                                    <div style={{height: 20}}/>
                                    <label data-necessary={livesWith === 'father' || livesWith === 'both' ? 'yes' : ''}
                                           htmlFor={ids.fatherJob}>شغل پدر:</label>
                                    <input type="text"
                                           id={ids.fatherJob}
                                           className={"form-control" + (errors.fatherJob ? ' is-invalid' : '')}
                                           value={fatherJob}
                                           onChange={e => {
                                               const t = e.currentTarget.value;
                                               setFatherJob(StringDigitsConvertToPersian(t));
                                               setErrors(v => {
                                                   let x = {...v};
                                                   x.fatherJob = false;
                                                   return x;
                                               });
                                           }}
                                           onKeyUp={e => {
                                               if (e.which === 13)
                                                   (document.getElementById(ids.motherName) as HTMLInputElement).focus();
                                           }}
                                    />
                                    <div
                                        className={"invalid-feedback " + (errors.fatherJob ? 'd-block' : 'd-none')}>
                                        لطفا حداقل ۲ کاراکتر وارد کنید.
                                    </div>
                                    <div style={{height: 20}}/>
                                    <label data-necessary={livesWith === 'mother' || livesWith === 'both' ? 'yes' : ''}
                                           htmlFor={ids.motherName}>نام و نام‌خانوادگی مادر:</label>
                                    <input type="text"
                                           id={ids.motherName}
                                           className={"form-control" + (errors.motherName ? ' is-invalid' : '')}
                                           value={motherName}
                                           onChange={e => {
                                               const t = e.currentTarget.value;
                                               setMotherName(StringDigitsConvertToPersian(t));
                                               setErrors(v => {
                                                   let x = {...v};
                                                   x.motherName = false;
                                                   return x;
                                               });
                                           }}
                                           onKeyUp={e => {
                                               if (e.which === 13)
                                                   (document.getElementById(ids.motherTell) as HTMLInputElement).focus();
                                           }}
                                    />
                                    <div
                                        className={"invalid-feedback " + (errors.motherName ? 'd-block' : 'd-none')}>
                                        لطفا حداقل ۲ کاراکتر وارد کنید.
                                    </div>
                                    <div style={{height: 20}}/>
                                    <label data-necessary={livesWith === 'mother' || livesWith === 'both' ? 'yes' : ''}
                                           htmlFor={ids.motherTell}>تلفن‌همراه مادر:</label>
                                    <input type="text"
                                           id={ids.motherTell}
                                           className={"form-control" + (errors.motherTell ? ' is-invalid' : '')}
                                           value={motherTell}
                                           onChange={e => {
                                               const t = e.currentTarget.value;
                                               setMotherTell(StringDigitsConvertToPersian(t));
                                               setErrors(v => {
                                                   let x = {...v};
                                                   x.motherTell = false;
                                                   return x;
                                               });
                                           }}
                                           onKeyUp={e => {
                                               if (e.which === 13)
                                                   (document.getElementById(ids.motherCert) as HTMLInputElement).focus();
                                           }}
                                    />
                                    <div
                                        className={"invalid-feedback " + (errors.motherTell ? 'd-block' : 'd-none')}>لطفا
                                        تلفن همراه را بصورت ۱۱ رقمی وارد کنید.
                                    </div>
                                    <div style={{height: 20}}/>
                                    <label data-necessary={livesWith === 'mother' || livesWith === 'both' ? 'yes' : ''}
                                           htmlFor={ids.motherCert}>مدرک تحصیلی مادر:</label>
                                    <input type="text"
                                           id={ids.motherCert}
                                           className={"form-control" + (errors.motherCert ? ' is-invalid' : '')}
                                           value={motherCert}
                                           onChange={e => {
                                               const t = e.currentTarget.value;
                                               setMotherCert(StringDigitsConvertToPersian(t));
                                               setErrors(v => {
                                                   let x = {...v};
                                                   x.motherCert = false;
                                                   return x;
                                               });
                                           }}
                                           onKeyUp={e => {
                                               if (e.which === 13)
                                                   (document.getElementById(ids.fatherJob) as HTMLInputElement).focus();
                                           }}
                                    />
                                    <div
                                        className={"invalid-feedback " + (errors.motherCert ? 'd-block' : 'd-none')}>
                                        لطفا حداقل ۲ کاراکتر وارد کنید.
                                    </div>
                                    <div style={{height: 20}}/>
                                    <label data-necessary={livesWith === 'mother' || livesWith === 'both' ? 'yes' : ''}
                                           htmlFor={ids.motherJob}>شغل مادر:</label>
                                    <input type="text"
                                           id={ids.motherJob}
                                           className={"form-control" + (errors.motherJob ? ' is-invalid' : '')}
                                           value={motherJob}
                                           onChange={e => {
                                               const t = e.currentTarget.value;
                                               setMotherJob(StringDigitsConvertToPersian(t));
                                               setErrors(v => {
                                                   let x = {...v};
                                                   x.motherJob = false;
                                                   return x;
                                               });
                                           }}
                                           onKeyUp={e => {
                                               if (e.which === 13)
                                                   (document.getElementById(ids.zipcode) as HTMLInputElement).focus();
                                           }}
                                    />
                                    <div
                                        className={"invalid-feedback " + (errors.motherJob ? 'd-block' : 'd-none')}>
                                        لطفا حداقل ۲ کاراکتر وارد کنید.
                                    </div>
                                    <div style={{height: 20}}/>
                                </div>
                                <div className="col-lg-4 col-md-6">
                                    <label data-necessary={'yes'} style={{marginBottom: 5}}>دانش‌آموز با چه کسی زندگی
                                        می‌کند؟</label>
                                    <button
                                        className={"techaran-radio-box" + (livesWith === 'both' ? ' active' : '')}
                                        onClick={() => {
                                            setLivesWith('both');
                                            setErrors(v => {
                                                let x = {...v};
                                                x.livesWith = false;
                                                return x;
                                            });
                                        }}>
                                        <div><i/></div>
                                        <span>هر دو</span>
                                    </button>
                                    <button
                                        className={"techaran-radio-box" + (livesWith === 'father' ? ' active' : '')}
                                        onClick={() => {
                                            setLivesWith('father');
                                            setErrors(v => {
                                                let x = {...v};
                                                x.livesWith = false;
                                                return x;
                                            });
                                        }}>
                                        <div><i/></div>
                                        <span>تنها پدر</span>
                                    </button>
                                    <button
                                        className={"techaran-radio-box" + (livesWith === 'mother' ? ' active' : '')}
                                        onClick={() => {
                                            setLivesWith('mother');
                                            setErrors(v => {
                                                let x = {...v};
                                                x.livesWith = false;
                                                return x;
                                            });
                                        }}>
                                        <div><i/></div>
                                        <span>تنها مادر</span>
                                    </button>
                                    <div
                                        className={"invalid-feedback " + (errors.livesWith ? 'd-block' : 'd-none')}>
                                        لطفا یک مورد را انتخاب کنید.
                                    </div>
                                    <div style={{height: 2}}/>
                                    {
                                        livesWith === 'both' ?
                                            <>
                                                <label data-necessary={'yes'} style={{marginBottom: 5}}>دریافت
                                                    پیامک‌ها توسط:</label>
                                                <button
                                                    className={"techaran-checkbox" + (whoGetsSMS === 'father' ? ' active' : '')}
                                                    onClick={() => {
                                                        setWhoGetsSMS('father');
                                                        setErrors(v => {
                                                            let x = {...v};
                                                            x.whoGetsSMS = false;
                                                            return x;
                                                        });
                                                    }}>
                                                    <i><CheckIcon/></i>
                                                    <span>پدر</span>
                                                </button>
                                                <button
                                                    className={"techaran-checkbox" + (whoGetsSMS === 'mother' ? ' active' : '')}
                                                    onClick={() => {
                                                        setWhoGetsSMS('mother');
                                                        setErrors(v => {
                                                            let x = {...v};
                                                            x.whoGetsSMS = false;
                                                            return x;
                                                        });
                                                    }}>
                                                    <i><CheckIcon/></i>
                                                    <span>مادر</span>
                                                </button>
                                                <div
                                                    className={"invalid-feedback " + (errors.whoGetsSMS ? 'd-block' : 'd-none')}>
                                                    لطفا یک مورد را انتخاب کنید.
                                                </div>
                                            </> : null
                                    }
                                    <div style={{height: 20}}/>
                                    <label data-necessary={"yes"} htmlFor={ids.zipcode}>کدپستی منزل:</label>
                                    <input type="text"
                                           id={ids.zipcode}
                                           className={"form-control" + (errors.zipcode ? ' is-invalid' : '')}
                                           value={zipcode}
                                           onChange={e => {
                                               const t = e.currentTarget.value;
                                               setZipcode(StringDigitsConvertToPersian(t));
                                               setErrors(v => {
                                                   let x = {...v};
                                                   x.zipcode = false;
                                                   return x;
                                               });
                                           }}
                                           onKeyUp={e => {
                                               if (e.which === 13)
                                                   (document.getElementById(ids.address) as HTMLInputElement).focus();
                                           }}
                                    />
                                    <div
                                        className={"invalid-feedback " + (errors.zipcode ? 'd-block' : 'd-none')}>
                                        لطفا این سطر را کامل کنید.
                                    </div>
                                    <div style={{height: 20}}/>
                                    <label data-necessary={"yes"} htmlFor={ids.address}>نشانی منزل:</label>
                                    <input type="text"
                                           id={ids.address}
                                           className={"form-control" + (errors.address ? ' is-invalid' : '')}
                                           value={address}
                                           onChange={e => {
                                               const t = e.currentTarget.value;
                                               setAddress(StringDigitsConvertToPersian(t));
                                               setErrors(v => {
                                                   let x = {...v};
                                                   x.address = false;
                                                   return x;
                                               });
                                           }}
                                           onKeyUp={e => {
                                               if (e.which === 13)
                                                   (document.getElementById(ids.address) as HTMLInputElement).focus();
                                           }}
                                    />
                                    <div
                                        className={"invalid-feedback " + (errors.address ? 'd-block' : 'd-none')}>
                                        لطفا نشانی را بصورت کامل وارد کنید.
                                    </div>
                                    <div style={{height: 20}}/>
                                </div>
                            </div>
                            <div className="d-flex justify-content-end align-items-center" style={{paddingTop: 10}}>
                                <button className="btn-pay" onClick={saveData}>
                                    <b>ذخیره نهایی اطلاعات</b>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};